<div id="existingClient" class="container mx-auto max-w-5xl" data-cy="existing-client">
  <div [formGroup]="control" class="form">
    <ife-title
      [title]="'modules.evSimulator.steps.existingClient.fields.existingClient.title' | translate"
      data-cy="existing-client-title"
    ></ife-title>

    <div class="flex flex-wrap md:mt-8 justify-center">
      <ife-checkbox
        id="isExistingClient"
        data-cy="yes"
        class="w-full mb-8 md:mr-16 sm:w-auto"
        [value]="true"
        [formControlName]="formName"
        [image]="'./assets/general/img/yes.svg'"
        [caption]="'general.yes' | translate"
      >
      </ife-checkbox>
      <ife-checkbox
        id="nonExistedClient"
        data-cy="no"
        class="w-full mb-8 sm:w-auto"
        [value]="false"
        [formControlName]="formName"
        [image]="'./assets/general/img/no.svg'"
        [caption]="'general.no' | translate"
      >
      </ife-checkbox>
    </div>
  </div>

  <div
    [@inOutAnimation]
    id="not-existed-client"
    class="flex flex-col items-center my-16 "
    data-cy="not-existed-client"
    *ngIf="control.get(this.formName).value === false"
  >
    <ife-notification
      class="mb-16"
      [notificationType]="notificationType.info"
      [notificationString]="'modules.evSimulator.steps.existingClient.fields.notExistedClient.infoBox' | translate"
    >
    </ife-notification>

    <div class="flex flex-col md:flex-row md:mb-4 items-center justify-center w-full box-shadow-small rounded-xl p-14">
      <span class="mb-3 md:mb-0">{{ 'modules.evSimulator.steps.existingClient.fields.notExistedClient.description' | translate }}</span>
      <a
        id="navigate-main-web"
        class="flex items-center justify-center btn btn-primary w-96 md:ml-8"
        data-cy="navigate-main-web"
        [href]="'modules.evSimulator.steps.existingClient.fields.notExistedClient.btnToWebsite.link' | translate"
      >
        {{ 'modules.evSimulator.steps.existingClient.fields.notExistedClient.btnToWebsite.label' | translate }}
      </a>
    </div>

    <div class="flex justify-center items-center mt-7">
      <img src="./assets/general/img/link.svg" alt="navigate-next" />
      <a id="navigate-next" class="text-primary text-base font-bold pl-2 cursor-pointer" data-cy="navigate-next" (click)="proceedToNext()">
        <span>{{ 'modules.evSimulator.steps.existingClient.fields.notExistedClient.goNext.label' | translate }}</span>
      </a>
    </div>
  </div>
</div>

<ife-navigation
  [showNext]="control?.valid"
  [showPrevious]="false"
  (nextStep)="navigate()"
  (previousStep)="navigateBack()"
>
</ife-navigation>
